import React from 'react'
import { observer } from 'mobx-react-lite'
import { useNavigate, useParams } from 'react-router-dom'
import ProductCard from '../../components/ProductCard/ProductCard'
import './styles/Devices.scss'
import { apiClient } from '../../service/ApiClient'
import { Location } from '../../types/models/Locations'
import { Device } from '../../types/models/Device'
import { Button } from '@mui/material'
import CreateIssue from '../../components/modals/CreateIssue'
import RootStore from '../../store/RootStore'

type Props = {
  basePath?: string
}

type Data = {
  location: Location[]
  devices: Device[]
  parrentId: number | undefined | null
  pathToMain: string | null
}

const Devices = observer((props: Props) => {
  const { basePath = '/devices' } = props
  const { id = '' } = useParams()
  const navigate = useNavigate()
  const [data, setData] = React.useState<Data>()
  const defaultLocation = RootStore.settingsStore.locationId

  const issues = RootStore.userAction.issues

  const hundleFetch = React.useCallback(
    async (id: string | number | undefined) => {
      try {
        if (id || defaultLocation) {
          const { data } = await apiClient.get(
            `/location/${id ? id : defaultLocation}`
          )
          // console.log('Fetch:', id)

          if(data) {
            const pathToMain = data.pathToMain
            ? `${data.pathToMain} → ${data.name}`
            : data.name
            RootStore.userAction.setCurrentPath(pathToMain)
            setData({
              location: data.child,
              devices: data.devices,
              parrentId: data.parrentId,
              pathToMain,
            })
          } else {
            const { data } = await apiClient.get(`/location`)
            RootStore.userAction.setCurrentPath(null)
            setData({
              location: data,
              devices: [],
              parrentId: null,
              pathToMain: null,
            })
          }
          
        } else {
          const { data } = await apiClient.get(`/location`)
          RootStore.userAction.setCurrentPath(null)
          setData({
            location: data,
            devices: [],
            parrentId: null,
            pathToMain: null,
          })
        }
      } catch (error) {
        setTimeout(() => {
          hundleFetch(id)
        }, 3000)
      }
    },
    [defaultLocation]
  )

  React.useEffect(() => {
    hundleFetch(id)
  }, [hundleFetch, id])

  const handleModalClose = () => {
    // Обновляем данные после закрытия модала
    hundleFetch(id)
  }

  const hundleNewIssue = (id: number | string) => {
    const device = devices?.find((device) => device.id === id)
    // console.log('Started before', device?.is_started)
    RootStore.modalsUi.hundleCreateIssue(true, device)
  }

  if (!data)
    return (
      <div className="Home-content">
        <p>Загрузка...</p>
      </div>
    )

  const { location, devices, parrentId, pathToMain } = data

  return (
    <div className="Devices">
      <div className="Devices-filters">
        <div className="Devices-filters-content">
          {id && id !== defaultLocation ? (
            <Button
              className="Devices-filters-content-button"
              onClick={() => {
                navigate(parrentId ? `${basePath}/${parrentId}` : `${basePath}`)
              }}
            >
              Назад
            </Button>
          ) : (
            ''
          )}
          <div className="Devices-filters-content-path">{pathToMain}</div>
        </div>
      </div>
      <div className="Devices-layout">
        <div className="Devices-content">
          {devices?.length === 0 && location?.length === 0
            ? 'Ничего нет'
            : null}
          {location?.map((locate) => {
            const currentIssues = issues?.filter((issue) => {
              const path = locate.pathToMain
                ? `${locate.pathToMain} → ${locate.name}`
                : locate.name
              // console.log(path)
              return issue.locationPath?.includes(path)
            })
            return (
              <ProductCard
                key={locate.id}
                onClick={(e: any) => {
                  e.preventDefault()
                  navigate(`${basePath}/${locate.id}`)
                }}
                title={locate.name}
                type="folder"
                currentIssues={currentIssues?.length}
              />
            )
          }) ?? <p>Загрузка...</p>}
          {devices?.map((device) => {
            return (
              <ProductCard
                key={device.id}
                onClick={() => {
                  hundleNewIssue(device.id)
                }}
                title={device.name}
                type="item"
              />
            )
          })}
        </div>
      </div>
      <CreateIssue onClose={handleModalClose} />
    </div>
  )
})

export default Devices
